/**
 * Communication Service Hooks
 * React hooks for accessing communication services
 */
import { useCCMS } from '../useCCMS';
/**
 * Hook to access all communication services
 */
export function useCommunicationServices() {
    const { services } = useCCMS();
    if (!services?.communication) {
        throw new Error('Communication services not configured. Add communication config to CCMSProvider services prop.');
    }
    return services.communication;
}
/**
 * Hook to access EmailService
 */
export function useEmailService() {
    const { email } = useCommunicationServices();
    return email;
}
/**
 * Hook to access SmsService
 */
export function useSmsService() {
    const { sms } = useCommunicationServices();
    return sms;
}
/**
 * Hook to access PushNotificationService
 */
export function usePushNotificationService() {
    const { pushNotification } = useCommunicationServices();
    return pushNotification;
}
/**
 * Hook to access WhatsAppService
 */
export function useWhatsAppService() {
    const { whatsApp } = useCommunicationServices();
    return whatsApp;
}
/**
 * Hook to access TemplateService
 */
export function useTemplateService() {
    const { template } = useCommunicationServices();
    return template;
}
/**
 * Hook to access DeviceService
 */
export function useDeviceService() {
    const { device } = useCommunicationServices();
    return device;
}
/**
 * Hook to access NotificationInboxService (GET /api/notifications/me)
 */
export function useNotificationInboxService() {
    const { notificationInbox } = useCommunicationServices();
    return notificationInbox;
}
/**
 * Hook to access WhatsAppTemplateService (api/whatsapp-templates: library, message links, creator)
 */
export function useWhatsAppTemplateService() {
    const { whatsAppTemplates } = useCommunicationServices();
    return whatsAppTemplates;
}
//# sourceMappingURL=useCommunicationServices.js.map